<template>
	<div class="project" @click="goToProject()">
		<img class="project__logo"
		     :src="logo"></img>
		<div class="project__content">
			<ExternalIcon class="external-icon"/>
			<h2 class="project__title">
				{{project.title}}
			</h2>
			<p class="project__description">
				{{project.description}}
			</p>
			<span class="tags"
			      v-for="tag in project.tags">
				#{{tag}}
			</span>
		</div>
	</div>
</template>
<script>
import ExternalIcon from '@/assets/external.vue';

export default {
	props: ['project'],
	components: {
		ExternalIcon,
	},
	computed: {
		logo() {
			return require(`../assets/${this.project.logo}`);
		}
	},
	methods: {
		goToProject() {
			window.open(this.project.url ,'_blank');
		},
	},
}
</script>
<style lang="scss">
.project {
	margin-top: 20px;
	cursor: pointer;
	padding: 3.5rem;
	display: flex;
	align-items: center;
	background-color: var(--light);
	border: solid 1px var(--grey);
	border-radius: 18px;
	flex: 1;
	position: relative;

	@media screen and (max-width: 700px) {
		margin-left: 20px;
		padding: 30px;
	}

	@media screen and (max-width: 550px) {
		padding: 20px;
		border-radius: 20px;
		margin-left: 0px;
	}

	img {
		width: 10rem;
		max-width: 102px;
		height: auto;
		margin-right: 40px;
		flex-shrink: 0;


		@media screen and (max-width: 700px) {
			position: absolute;
			margin: 0;
			top: 10px;
			right: 10px;
			width: 12%;
		}
		@media screen and (max-width: 550px) {
			width: 12rem;
		}
	}

	&:last-child {
		margin-bottom: 30px;
	}

	.external-icon {
		position: absolute;
		top: 10px;
		right: 10px;
		max-width: 20px;
		min-width: 12px;
		width: 2rem;
		@media screen and (max-width: 550px) {
			display: none;
		}
	}

	&__content {
		>* {
			margin: 0px;
		}

		h2 {
			font-family: 'PT Sans', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
			margin-bottom: 2rem;
			font-size: 2.8rem;
			font-weight: 800;
		}

		p {
			font-size: 1.8rem;
			margin-bottom: 2rem;
		}

		@media screen and (min-width: 1200px) {
			h2 {
				font-size: 2.2rem;
			}

			p {
				font-size: 1.2rem;
			}
		}

		@media screen and (max-width: 700px) {
			h2 {
				font-size: 3.5rem;
			}
		}

		@media screen and (max-width: 550px) {
			h2 {
				font-size: 5.5rem;
				margin-bottom: 5rem;
			}
			p {
				font-size: 4rem;
			}
			.tags {
				font-size: 3.5rem;
			}
		}

		.tags {
			margin-right: 5px;
		}
	}
}
</style>